
const transformsSettings = {
    tabSize: 2,
    indentUnit: 2,
};

export default transformsSettings;